import React, {useEffect} from 'react'
import {useAccessToken} from '@salesforce/commerce-sdk-react'
import useCustomFetch from '../../../../hooks/useFetchContent'
import {Box} from '@salesforce/retail-react-app/app/components/shared/ui'
import {styleContent} from './index.style'

const slotIDs = 'home-promo-banners'

const WesternStyleContent = () => {
    const {token} = useAccessToken()
    const {response} = useCustomFetch(token, slotIDs, true)

    useEffect(() => {
        const targets = document.querySelectorAll('.fade-in')
        if (targets?.length > 0) {
            const observer = new IntersectionObserver(
                (entries) => {
                    entries?.forEach((entry) => {
                        if (entry?.isIntersecting) {
                            entry.target.classList.add('in-view')
                            observer.unobserve(entry.target)
                        } else {
                            entry.target.classList.remove('in-view')
                        }
                    })
                },
                {
                    threshold: 0.25
                }
            )

            targets.forEach((target) => observer.observe(target))

            return () => observer.disconnect()
        }
    }, [response])

    return (
        <Box
            data-sid="home-promo-banners"
            data-content-tracking="home_promo_banners"
            sx={styleContent}
        >
            <div dangerouslySetInnerHTML={{__html: response}}></div>
        </Box>
    )
}

export default WesternStyleContent
